import { FC } from "react";
import { ISvgProps } from "common/models/components/ui/ISvgProps";

export const SvgCheck: FC<ISvgProps> = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 1L8 14.9994L1 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
